// removed by extract-text-webpack-plugin
module.exports = {"Modal":"Modal_Modal_1FmW4"};


//////////////////
// WEBPACK FOOTER
// ./src/static/home/solutions/Modal/Modal.css
// module id = 429
// module chunks = 4